export default "__VITE_ASSET__VkhSiE2o__"